import React, {useState} from 'react';
import {Upload, Button, notification} from 'antd';
import {UploadOutlined} from '@ant-design/icons';
import api from '../../config/axiosConfig';
import st from './Uploader.module.scss';

const ExcelUploader = () => {
    const [fileList, setFileList] = useState([]);
    const [uploading, setUploading] = useState(false);

    const handleUpload = async () => {
        if (fileList.length === 0) {
            notification.warning({
                message: 'No File Selected',
                description: 'Please select a file to upload.',
                placement: 'topRight',
            });
            return;
        }

        const formData = new FormData();
        formData.append('file', fileList[0]);

        setUploading(true);
        try {
            const response = await api.post('payments/import', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            notification.success({
                message: 'Upload Successful',
                description: 'Your file has been uploaded successfully.',
                placement: 'topRight',
            });
            setFileList([]);
        } catch (error) {
            notification.error({
                message: 'Upload Failed',
                description: error.response?.data?.message || 'Something went wrong. Please try again.',
                placement: 'topRight',
            });
        } finally {
            setUploading(false);
        }
    };

    const props = {
        onRemove: (file) => {
            setFileList((prev) => prev.filter((item) => item.uid !== file.uid));
        },
        beforeUpload: (file) => {
            setFileList([file]);
            return false;
        },
        fileList,
    };

    return (
        <div className={st.uploadContainer}>
            <Upload {...props} accept=".xlsx,.xls">
                <Button icon={<UploadOutlined/>}>Select File</Button>
            </Upload>
            {fileList.length !== 0 &&
                <Button
                    type="primary"
                    onClick={handleUpload}
                    disabled={fileList.length === 0 || uploading}
                    loading={uploading}
                >
                    {uploading ? 'Uploading...' : 'Start Upload'}
                </Button>}
        </div>
    );
};

export default ExcelUploader;
